import * as React from 'react'
import styled from 'styled-components'

import TncModal from '../TncModal2/TncModal'
import { TncTitle } from '../TermsAndConditions/TnCContent'

const StyledLink = styled.a`
  cursor: pointer;
`

function TncModalLink({ children, zIndex, tab, onClick, ...theProps }) {
  const [isModalShown, setModalShown] = React.useState(false)

  return (
    <StyledLink
      zIndex={10021}
      {...theProps}
      onClick={e => {
        e.preventDefault()
        onClick && onClick(e)
        setModalShown(true)
      }}
    >
      {children || <TncTitle />}
      <TncModal
        zIndex={zIndex}
        show={isModalShown}
        onClose={() => {
          setModalShown(false)
        }}
      />
    </StyledLink>
  )
}

export default TncModalLink
